import { useUpdateUserAlarmTypeGroups } from '@hakimo-ui/hakimo/data-access';
import {
  ModifyUserAlarmTypeGroupsPayload,
  User,
} from '@hakimo-ui/hakimo/types';
import { toast } from '@hakimo-ui/hakimo/util';
import { Alert, Button, Modal } from '@hakimo-ui/shared/ui-base';
import { useState } from 'react';
import { AlarmTypeGroupMultiSelect } from './AlarmTypeGroupMultiSelect';

interface Props {
  selectedUsers: User[];
  onClose: () => void;
}

export function AssignFiltersModal(props: Props) {
  const { selectedUsers, onClose } = props;
  const [selectedAlarmTypeGroupIds, setSelectedAlarmTypeGroupIds] = useState<
    number[]
  >([]);

  const onSuccess = () => {
    toast('Alarm type groups assigned successfully');
    onClose();
  };

  const mutation = useUpdateUserAlarmTypeGroups(onSuccess);

  const onChangeSelectedAlarmTypeGroups = (val: number[]) =>
    setSelectedAlarmTypeGroupIds(val);

  const onSubmit = () => {
    selectedUsers.forEach((user) => {
      const alarmTypeGroupPayload: ModifyUserAlarmTypeGroupsPayload = {
        operation: 'add',
        alarmtype_group_ids: selectedAlarmTypeGroupIds.map((id) => String(id)),
        target_user_id: user.id,
      };
      mutation.mutate(alarmTypeGroupPayload);
    });
  };

  const actions = (
    <>
      <Button variant="primary" onClick={onSubmit} loading={mutation.isLoading}>
        Submit
      </Button>
      <Button onClick={onClose}>Cancel</Button>
    </>
  );

  return (
    <Modal
      open
      onClose={onClose}
      closable
      footer={actions}
      title="Assign Alarm Type Groups"
    >
      <div className="space-y-6 p-4 px-8 text-sm">
        {mutation.isError && (
          <Alert type="error">{mutation.error.message}</Alert>
        )}
        <Alert type="info">
          Assign alarm type groups to filter the alarms that users can see.
        </Alert>

        <div>
          <div className="my-2 italic">Selected Users:</div>
          <div className="grid grid-cols-2 gap-2">
            <span className="font-bold">Name</span>
            <span className="font-bold">Email Id</span>
            {selectedUsers.map((usr) => (
              <>
                <span>{usr.name}</span>
                <span>{usr.email}</span>
              </>
            ))}
          </div>
        </div>
        <div className="mt-4">
          <AlarmTypeGroupMultiSelect
            onChange={onChangeSelectedAlarmTypeGroups}
            selectedAlarmTypeGroupIds={selectedAlarmTypeGroupIds}
            label="Alarm Type Groups"
          />
        </div>
      </div>
    </Modal>
  );
}

export default AssignFiltersModal;
